/* eslint-disable */
const translation = require('./en.json');

export const en = {
    ...translation,
};
